<script lang="ts">
	import { page } from '$app/stores';

	export let tag: Tag | undefined = undefined;
	let className = '';

	export { className as class };
</script>

{#if !$$slots.default}
	<li class="text-md h-6 rounded border-[1px] border-primary px-2 font-light text-primary">
		{#if tag}
			<a href="{$page.data?.location?.origin}/artigos/sobre/tag/{tag.slug}">
				{tag.name}
			</a>
		{/if}
	</li>
{:else}
	<div
		class="text-md h-6 rounded border-[1px] border-primary px-2 font-light text-primary {className}"
	>
		<slot />
	</div>
{/if}
